import React, {
  FC,
  useReducer,
  useState,
  memo,
} from "react";
import { claimInitialState, ClaimQueryParamReducer } from "src/pages/copayClaimsHCP/reducer";
import { CopayClaimsProps } from "src/pages/copayClaimsHCP/types";
import AuthSubHeader from "../authSubHeader";
import FooterText from "../footerText";

const CopayClaims: FC<CopayClaimsProps> = ({
  initialState,
  tabs,
}) => {
  const [queryParams] = useReducer(ClaimQueryParamReducer, claimInitialState);
  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const activeTabObj = tabs.find((t) => t.key === activeTab)!;

  return (
    <section className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill action-dashboard">
      <div className="bg-mist py-2">
        <div className="container-fluid">
          <AuthSubHeader />
        </div>
      </div>
      <div className="container-fluid pt-3 d-flex flex-column flex-fill">
        {/* Header */}
        <div className="d-flex align-items-center mb-3 flex-wrap gap-4">
          <h2 className="m-0 page-heading">Co-Pay Cases</h2>
        </div>
        {/* Tabs */}
        <div className="nav nav-pills gap-2 sticky-top bg-white p-2 rounded-2 border shadow-sm">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>
        {/* Active Tab Content */}
        <div className="tab-content d-flex flex-column flex-fill">
          <div className="tab-pane show active fade d-flex flex-column flex-fill">
            <activeTabObj.Component
              currentPage={queryParams[activeTabObj.pageKey]}
              initialState={initialState}
              activeTab={activeTabObj}
            />
          </div>
        </div>
      </div>
      <FooterText footerType="black" />
    </section>
  );
};

export default memo(CopayClaims);
